import { Box, styled } from "@mui/material";

const ContentSectionRoot = styled(Box)({
  flex: 1,
  minWidth: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

const ContentSection = ({ children, className, sx, ...rest }) => (
  <ContentSectionRoot className={className} sx={sx} {...rest}>
    {children}
  </ContentSectionRoot>
);

export default ContentSection;
